package com.milta.feature.delivery.data.dto

import com.milta.feature.delivery.domain.entity.AddressSuggestion
import kotlinx.serialization.Serializable

/** Response item for GET api/v1/addresses/autocomplete. */
@Serializable
data class AddressSuggestionResponse(
    val label: String,
    val latitude: Double,
    val longitude: Double,
)

fun AddressSuggestionResponse.toDomain() = AddressSuggestion(
    label = label,
    latitude = latitude,
    longitude = longitude,
)
